
export function RadialProgressSetup() {

    var RadialProgress = function(size, barSize, barColor, backgroundColor, textColor, zIndex) {

        this.radialProgress = document.getElementById('radial-progress');

        if(!this.radialProgress)
            return;

        this.progress = 0;
        var requestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame;

        barSize = (barSize % 2 === 1) ? (barSize + 1) : barSize;
        var innerSize = size - barSize;
        var innerMargin = barSize / 2;

        document.querySelector('.radial-progress').style.width = size + 'px';
        document.querySelector('.radial-progress').style.height = size + 'px';
        document.querySelector('.radial-progress').style.zIndex = size + 'px';
        document.querySelector('.radial-progress').style.zIndex = size + 'px';

        if (document.querySelector('.radial-progress .inner-circle') !== null) {
            document.querySelector('.radial-progress .inner-circle').style.width = innerSize + 'px';
            document.querySelector('.radial-progress .inner-circle').style.height = innerSize + 'px';
            document.querySelector('.radial-progress .inner-circle').style.marginTop = innerMargin + 'px';
            document.querySelector('.radial-progress .inner-circle').style.marginLeft = innerMargin + 'px';
            document.querySelector('.radial-progress .inner-circle').style.backgroundColor = backgroundColor;
        }

        this.setMaskHeightAndWidth = function (size) {
            var masks = document.querySelectorAll('.radial-progress .outer-circle .mask');
            if (masks.length > 0) {
                masks.forEach(function (mask) {
                    mask.style.width = size + 'px';
                    mask.style.height = size + 'px';
                });
            }

        };

        this.setFillWidths = function (size) {
            var fills = document.querySelectorAll('.radial-progress .outer-circle .fill');
            if (fills.length > 0) {
                fills.forEach(function (fill) {
                    fill.style.width = size + 'px';
                    fill.style.height = size + 'px';
                });
            }
        };

        this.setMaskClips =  function (size) {
            var masks = document.querySelectorAll('.radial-progress .outer-circle .mask');
            if (masks.length > 0) {
                masks.forEach(function (mask) {
                    mask.style.clip = 'rect(0px, ' + size + 'px, ' + size + 'px, ' + size / 2 + 'px)';
                })
            }
        };

        this.setFills = function (size) {
            var fills = document.querySelectorAll('.radial-progress .outer-circle .mask .fill');

            if (fills.length > 0) {
                fills.forEach(function (fill) {
                    fill.style.clip = 'rect(0px, ' + size / 2 + 'px, ' + size + 'px, 0px)';
                })
            }
        };

        this.setBarColor = function (barColor) {
            var fills = document.querySelectorAll('.radial-progress .outer-circle .mask .fill');

            if (fills.length > 0) {
                fills.forEach(function (fill) {
                    fill.style.backgroundColor = barColor;
                })
            }
        };

        this.setMaskHeightAndWidth(size);
        this.setFillWidths(size);
        this.setMaskClips(size);
        this.setFills(size);
        this.setBarColor(barColor);

        this.setProgress = function(progress, duration) {
            progress = (progress > 100) ? 100 : progress;
            var self = this;
            var $maskFull = this.radialProgress.getElementsByClassName('mask full')[0];
            var $fill = this.radialProgress.getElementsByClassName('fill');
            var $fillFix = this.radialProgress.getElementsByClassName('fill fix')[0];
            var deltaProgress = (progress - this.progress) / (duration * 60);

            function step() {
                self.progress += deltaProgress;
                self.progress = (self.progress > progress) ? progress : self.progress;
                var rotate = self.progress * 1.8;
                $maskFull.style.transform = 'rotate(' + rotate + 'deg)';

                for (var i = 0; i < $fill.length; ++i) {
                    $fill[i].style.transform = 'rotate(' + rotate + 'deg)';
                }

                $fillFix.style.transform = 'rotate(' + 2 * rotate + 'deg)';

                if (self.progress < progress) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        };
    };


    return RadialProgress;
}